import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from "./views/App";

// Xarxa de seguretat: algunes extensions del navegador (o builds antigues en
// caché) injecten 'web-vitals', que llança
// "Cannot read properties of undefined (reading 'startTime')" dins de
// reportAllChanges. No és un error de l'app; l'empassem perquè no trenqui res.
if (typeof window !== 'undefined') {
    const esErrorWebVitals = (msg?: string, stack?: string) => {
        const m = (msg || '') + ' ' + (stack || '');
        return m.includes('startTime')
            || m.includes('reportAllChanges')
            || m.includes('web-vitals');
    };

    window.addEventListener('error', (e) => {
        const stack = e.error && typeof e.error.stack === 'string' ? e.error.stack : '';
        if (esErrorWebVitals(e.message, stack)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }
    }, true);

    window.addEventListener('unhandledrejection', (e) => {
        const reason: any = e.reason;
        const msg = reason && (reason.message || String(reason));
        const stack = reason && typeof reason.stack === 'string' ? reason.stack : '';
        if (esErrorWebVitals(msg, stack)) {
            e.preventDefault();
        }
    });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
